import axiosConfig from "../../../utils/axiosConfig";
import { VIEW_OPTIONS } from "./constants";

const BASE_URLS = {
  [VIEW_OPTIONS[0].id]: "pages/memberships/freeze_lifecycle/currently_frozen",
  [VIEW_OPTIONS[1].id]: "pages/memberships/freeze_lifecycle/freeze_history"
};

export const api = {
  getFilters(params, view) {
    return axiosConfig.get(`${BASE_URLS[view]}/get_filters`, { params });
  },
  getTable(params, view) {
    return axiosConfig.post(`${BASE_URLS[view]}/get_table`, params);
  }
};
